/* TORO GROUP GLOBAL — idioma, entrada en escena y parallax */
(function () {
  'use strict';
  var LANGS = ['en', 'es', 'pt'], KEY = 'toro-lang';

  function current() {
    var v = document.documentElement.getAttribute('data-toro-lang');
    return LANGS.indexOf(v) > -1 ? v : 'en';
  }
  function set(lang, remember) {
    if (LANGS.indexOf(lang) < 0) return;
    document.documentElement.setAttribute('data-toro-lang', lang);
    if (remember) { try { localStorage.setItem(KEY, lang); } catch (e) {} }
    document.querySelectorAll('[data-toro-lang-btn]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-toro-lang-btn') === lang ? 'true' : 'false');
    });
    document.dispatchEvent(new CustomEvent('toro:lang', { detail: { lang: lang } }));
  }
  window.ToroLang = { get: current, set: set };

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-toro-lang-btn]');
    if (!b) return;
    e.preventDefault();
    set(b.getAttribute('data-toro-lang-btn'), true);
  });

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveals(root) {
    var els = (root || document).querySelectorAll('.toro-reveal:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Parallax suave: mismo cálculo del diseño (0.08 del desplazamiento) */
  function parallax() {
    if (reduce) return;
    var imgs = document.querySelectorAll('.parallax-img');
    if (!imgs.length) return;
    var ticking = false;
    function frame() {
      var vh = window.innerHeight;
      imgs.forEach(function (el) {
        var p = el.parentElement;
        if (!p) return;
        var r = p.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var offset = (r.top + r.height / 2 - vh / 2) * 0.08;
        /* Se escribe como variable para no pisar otras transformaciones
           (por ejemplo el espejado horizontal del hero). */
        el.style.setProperty('--toro-par', offset.toFixed(1) + 'px');
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(frame);
    }, { passive: true });
    frame();
  }

  /* Ancho real de la barra de scroll: el riel usa 100vw, que la incluye. */
  function scrollbar() {
    var w = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--toro-sbw', (w > 0 ? w : 0) + 'px');
  }
  window.addEventListener('resize', scrollbar);


  /* ── Cifras que suman al entrar en pantalla ─────────────────────────────
     Respeta el formato original: ≈US$3B, 9.8%, 3 days, 465,000.
     Solo anima la parte numérica y devuelve el texto exacto al terminar. */
  function counters() {
    var nodes = document.querySelectorAll(
      '.toro-stat b:not([data-counted]), .toro-hero__fact b:not([data-counted]), ' +
      '.toro-statcard__top b:not([data-counted]), .toro-breakdown__total b:not([data-counted])'
    );
    if (!nodes.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      nodes.forEach(function (n) { n.setAttribute('data-counted', '1'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        if (el.getAttribute('data-counted')) return;
        el.setAttribute('data-counted', '1');

        var raw = el.textContent.trim();
        var m = raw.match(/^(\D*?)([\d.,]+)(.*)$/);
        if (!m) return;
        var pre = m[1], numTxt = m[2], post = m[3];
        var decimals = (numTxt.split('.')[1] || '').length;
        var thousands = numTxt.indexOf(',') > -1;
        var target = parseFloat(numTxt.replace(/,/g, ''));
        if (!isFinite(target)) return;

        var dur = 1700, t0 = null, delay = (el.getAttribute('data-i') || 0) * 130;
        function fmt(v) {
          var s = decimals ? v.toFixed(decimals) : String(Math.round(v));
          if (thousands) s = s.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          return pre + s + post;
        }
        function step(ts) {
          if (t0 === null) t0 = ts;
          var p = Math.min(1, Math.max(0, (ts - t0 - delay) / dur));
          el.textContent = fmt(target * (1 - Math.pow(1 - p, 3)));
          if (p < 1) requestAnimationFrame(step);
          else el.textContent = raw;
        }
        el.textContent = fmt(0);
        requestAnimationFrame(step);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
    nodes.forEach(function (n, i) {
      n.setAttribute('data-i', i % 4);
      io.observe(n);
    });
  }

  /* ── Menú de móvil ─────────────────────────────────────────────────────
     El panel se muestra con la clase is-open, no con el atributo hidden:
     .toro-nav__links lleva display propio y hidden habría perdido contra él. */
  var MQ = '(max-width:880px)';
  function menu(scope) {
    (scope || document).querySelectorAll('[data-toro-nav]').forEach(function (nav) {
      if (nav.__menu) return;
      nav.__menu = true;
      var btn = nav.querySelector('[data-nav-toggle]');
      var panel = nav.querySelector('.toro-nav__links');
      if (!btn || !panel) return;

      function close() {
        if (!nav.classList.contains('is-open')) return;
        nav.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }
      function open() {
        nav.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (nav.classList.contains('is-open')) close(); else open();
      });

      /* Un enlace a la misma página no recarga nada, así que el panel se
         quedaría abierto encima del contenido. */
      panel.addEventListener('click', function (e) {
        if (e.target.closest('a')) close();
      });

      document.addEventListener('click', function (e) {
        if (!nav.contains(e.target)) close();
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && nav.classList.contains('is-open')) {
          close();
          btn.focus();
        }
      });

      if (window.matchMedia) {
        var mq = window.matchMedia(MQ);
        var onChange = function () { if (!mq.matches) close(); };
        if (mq.addEventListener) mq.addEventListener('change', onChange);
        else if (mq.addListener) mq.addListener(onChange);
      }
    });
  }

  function init() {
    scrollbar();
    /* Si la tienda tiene idiomas publicados en Shopify, manda el idioma de la URL
       y no la preferencia guardada: así /es nunca muestra el cuerpo en inglés. */
    var native = (window.TORO_NATIVE_LOCALES || 1) > 1;
    if (native) {
      var iso = (document.documentElement.getAttribute('lang') || 'en').slice(0, 2).toLowerCase();
      set(LANGS.indexOf(iso) > -1 ? iso : 'en', false);
      document.querySelectorAll('[data-toro-switcher]').forEach(function (el) {
        if (el.getAttribute('data-toro-switcher') === 'auto') el.hidden = true;
      });
    } else {
      set(current(), false);
    }
    reveals();
    parallax();
    counters();
    menu();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { reveals(e.target); parallax(); counters(); menu(e.target); });
})();
